import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { IoMdClose } from "react-icons/io";


export default function RejectAlertDialog(props) {
 

  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{position:'absolute',top:10,right:10,fontSize:'18px',cursor:'pointer'}} onClick={props.handleClose}>
            <IoMdClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
         <Typography variant='h4'> {"Reject User"}</Typography>
        </DialogTitle>
        <DialogContent >
              <TextField 
                id="outlined-basic" 
                label="Reason" 
                fullWidth
                required
                variant="outlined"
                value={props.data.reason}
                onChange={(e)=>props.handleChange(e.target.value)}
                sx={{marginBlock:'10px'}}
                />

        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
          <Button variant='contained' disabled={props.isLoading?true:false} color='secondary' onClick={props.handleSubmit}>Reject</Button>
         
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
